/**
 * assets/dm-video-mute.js — the mute/unmute toggle over an autoplaying
 * `dm-media-frame` video (the frame's `mute_control` param).
 *
 * Classic script, `defer`. The snippet emits one <script> per instance, so the
 * define is guarded. Deliberately NOT a DMElement: it binds one click listener
 * on its own button and holds no document/window listeners or observers, so
 * there is nothing for a section re-render to leak.
 */
(function () {
  'use strict';
  if (customElements.get('dm-video-mute')) return;

  class DMVideoMute extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      const video = this.closest('.dm-media-frame')?.querySelector('video');
      if (!button || !video) return;

      const sync = () => {
        const on = !video.muted;
        button.setAttribute('aria-pressed', String(on));
        button.setAttribute('aria-label', on ? button.dataset.labelMute : button.dataset.labelUnmute);
      };

      button.addEventListener('click', () => {
        video.muted = !video.muted;
        if (!video.muted && video.paused) video.play().catch(() => {});
        sync();
      });
      sync();
    }
  }

  customElements.define('dm-video-mute', DMVideoMute);
})();
